const TinyChevronRight = () => (
  <>
    <path
      fill="currentColor"
      d="M10.627 15.245a.41.41 0 0 1-.289-.111.38.38 0 0 1-.12-.293V9.164q0-.182.123-.293a.42.42 0 0 1 .289-.111q.04 0 .284.13l2.676 2.678q.093.092.143.199a.55.55 0 0 1 .05.235.55.55 0 0 1-.05.236.7.7 0 0 1-.143.199l-2.677 2.677a.5.5 0 0 1-.129.093.34.34 0 0 1-.157.037"
    />
  </>
)
export default TinyChevronRight
